import { ContainedTextField } from 'components/Form/FinalForm/Contained/ConainedTextField';
import { ContainedNumberField } from 'components/Form/FinalForm/Contained/ContainedNumberField';
import { AuctionField } from 'components/ListVehicles/components/CreateVehicleDialog/AuctionField';
import { MileageFields } from 'components/ListVehicles/components/CreateVehicleDialog/MileageFields';
import { OptionalEquipment } from 'components/ListVehicles/components/CreateVehicleDialog/OptionalEquipment';
import { SellerField } from 'components/ListVehicles/components/CreateVehicleDialog/SellerField';
import { VinField } from 'components/ListVehicles/components/CreateVehicleDialog/VinField';
import {
  AutomaticFields,
  BlueDriverInfoComponent,
  ManualFields
} from 'components/ListVehicles/components/CreateVehicleDialog/VinInfoDialog';
import { useCurrentUser } from 'hooks/selectors';
import { useField } from 'react-final-form';
import { useGetSellersQuery } from 'services/api';
import styled from 'styled-components';
import { normalizeFormattedField } from 'utils';
import { required, validateMinBid, validateReservePrice } from 'utils/validators';
import { VehicleActions } from '../VehicleActions';
import { KbbIcon } from 'pages/CreateVehicle/icons/KbbIcon';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1 100%;
  overflow-y: auto;
  max-height: 100%;
  min-height: 0;
  max-height: calc(100vh - 72px - 56px - 52px - 86px - 44px - 44px - 13px - 20px);
  padding: 0 1px 24px 1px;
`;

const KbbIconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: -10px;
  z-index: 99999;
  width: 69px;
  height: 39px;
  & svg {
    width: 100%;
    height: 100%;
  }
`;

export const VehicleInfoTab = () => {
  const {
    input: { value: vehicleId }
  } = useField(`vehicleId`);

  const {
    input: { value: uploadType }
  } = useField('upload_type', { subscription: { value: true } });

  return (
    <Wrapper>
      <KbbIconWrapper>
        <KbbIcon />
      </KbbIconWrapper>
      <FieldsWrapper>
        <ContainedTextField
          AdditionalComponent={() => <BlueDriverInfoComponent vehicleId={vehicleId} fieldName={'year'} />}
          validate={required}
          name="year"
          label="Year"
        />
        <ContainedTextField
          AdditionalComponent={() => <BlueDriverInfoComponent vehicleId={vehicleId} fieldName={'make'} />}
          validate={required}
          name="make"
          label="Make"
        />
        <ContainedTextField
          AdditionalComponent={() => <BlueDriverInfoComponent vehicleId={vehicleId} fieldName={'model'} />}
          validate={required}
          name="model"
          label="Model"
        />
        {uploadType === 'manual' ? <ManualFields /> : <AutomaticFields vehicleId={vehicleId} />}
        <ContainedNumberField
          validate={validateMinBid}
          name="starting_bid"
          label="Starting Bid"
          numberFormatProps={{
            allowNegative: false,
            thousandSeparator: true,
            decimalScale: 0,
            prefix: '$'
          }}
          parse={normalizeFormattedField}
        />
        <ContainedNumberField
          validate={validateReservePrice}
          name="reserve_price"
          parse={normalizeFormattedField}
          label="Reserve Price"
          numberFormatProps={{
            allowNegative: false,
            thousandSeparator: true,
            decimalScale: 0,
            prefix: '$'
          }}
        />
        <OptionalEquipment defaultOpen />
        <MileageFields vehicleId={vehicleId} />
      </FieldsWrapper>
      <VehicleActions />
    </Wrapper>
  );
};
